<main class="auth auth--centered">
  <section class="auth__panel auth__panel--wide">
    <div class="auth__card auth__card--centered">

      <span class="auth__mark-mobile">
        <svg width="44" height="44" viewBox="0 0 120 120" fill="none" aria-hidden="true">
          <defs>
            <clipPath id="frameForgot"><rect x="28.5" y="20.5" width="63" height="79" rx="15.5"></rect></clipPath>
          </defs>
          <rect x="26" y="18" width="68" height="84" rx="18" stroke="#1F4B3F" stroke-width="4.5"></rect>
          <g clip-path="url(#frameForgot)">
            <circle cx="46.5" cy="44" r="8.5" stroke="#C2A461" stroke-width="3.6"></circle>
            <path d="M27 83 L43 66 L52 72 L70 48 L93 83" stroke="#1F4B3F" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></path>
            <path d="M26 87 Q43 79 60 87 T95 87" stroke="#1F4B3F" stroke-width="3.6" stroke-linecap="round"></path>
            <path d="M26 96 Q45 87 62 96 T98 95" stroke="#C2A461" stroke-width="3.6" stroke-linecap="round"></path>
          </g>
        </svg>
      </span>

      <!-- Step 1: ask for the e-mail address -->
      <div data-id="forgot-request">
        <p class="auth__eyebrow">SaaS Admin</p>
        <h2 class="auth__title"><%= _lcs( 'Passwort vergessen?' ) %></h2>
        <p class="auth__subtitle"><%= _lcs( 'Gib die E-Mail-Adresse deines Kontos ein. Wir schicken dir einen Link, mit dem du ein neues Passwort vergeben kannst.' ) %></p>

        <form class="auth__form" data-id="forgot-form" autocomplete="on" novalidate>
          <div class="field">
            <label class="field__label" for="forgot-email"><%= _lcs( 'E-Mail' ) %></label>
            <div class="field__control">
              <span class="field__icon"><i class="icon icon--mail"></i></span>
              <input class="field__input" id="forgot-email" name="email" type="email"
                     inputmode="email" autocomplete="username"
                     placeholder="name@belturo.com" required />
            </div>
          </div>

          <p class="auth__error" data-id="forgot-error" role="alert" hidden></p>

          <button class="btn btn--primary btn--block" type="submit">
            <%= _lcs( 'Link anfordern' ) %>
            <i class="icon icon--arrow-right"></i>
          </button>
        </form>
      </div>

      <!-- Step 2: confirmation. Worded for both cases on purpose — the API does
           not say whether the address has an account. -->
      <div data-id="forgot-sent" hidden>
        <span class="auth__status"><i class="icon icon--mail"></i></span>
        <h2 class="auth__title"><%= _lcs( 'Schau in dein Postfach' ) %></h2>
        <!-- Filled by ForgotPasswordState (carries the address entered). -->
        <p class="auth__subtitle" data-id="forgot-sent-text"></p>
        <p class="auth__note"><%= _lcs( 'Keine E-Mail erhalten? Prüfe deinen Spam-Ordner oder fordere den Link erneut an.' ) %></p>
      </div>

      <a class="auth__link auth__back" href="#/login" data-id="btn-back-to-login">
        <i class="icon icon--arrow-left"></i>
        <%= _lcs( 'Zurück zur Anmeldung' ) %>
      </a>

      <div class="auth__hr"><%= _lcs( 'Geschützter Bereich' ) %></div>
      <p class="auth__note"><%= _lcs( 'BELTURO Cloud — Interner Operator-Zugang.' ) %></p>
    </div>
  </section>
</main>
